import toFormData from "@arelia-utils/helpers/toFormData";

const baseUrl = process.env.REACT_APP_API_ROOT ?? '/';
const sendBeacon = navigator.sendBeacon.bind(navigator);;

export function trackAppDownload(platform: string) {
  return sendBeacon(`${baseUrl}/api/connections/trackAppDownload`, toFormData({ platform }))
}